module.exports = __webpack_public_path__ + "static/img/banner_bg5.5bc642a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner_bg5.jpg
// module id = dJIO
// module chunks = 9